<template><SupplierPage /></template>

<script>
import SupplierPage from "./components/supplierPage";
export default { name: "Cooperation", components: { SupplierPage } };
</script>
